// Copyright (c) 2016 Deere & Company

import classNames from '../../shared/constants/ag-grid-class-names';
import {translate} from '../../../shared/services/translation-service';

export function getEmissionsPartSearchColumnDefinitions() {

    return [
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'partNumber',
            field: 'partNumber',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PART_NUMBER'),
            width: 200
        },
        {

            cellClass: classNames.cellLeftClassName,
            colId: 'qualifyForEmissions',
            field: 'qualifyForEmissions',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('QUALIFY_FOR_EMISSIONS'),
            width: 200
        }
    ];

}



// WEBPACK FOOTER //
// ./src/reports/emissions-part-search/report-services/column-definitions.js